/*
  made.straps finish tiles.

  Companion to blocks/ms-finish-tiles.liquid. The tiles do not select
  variants themselves. Activating one finds the matching radio inside the
  theme's own <variant-picker> and clicks it, so Ritual keeps ownership of
  price, stock, gallery and add to cart.

  <variant-picker> morphs its own DOM after every change, which destroys the
  inputs we just targeted, so nothing is cached: every lookup is fresh and a
  debounced observer re-syncs after each morph.

  Accessibility notes, because they are easy to undo by accident:
   - The row is a radiogroup. Exactly one tile is in the tab order at a time
     and the arrow keys move between them. That is the expected pattern for
     a one-of-N choice and it is what screen reader users will try.
   - Sold out state is read back from the theme's own radios on every sync,
     not just rendered once by Liquid, because availability changes when the
     other option (lug width, taper width) changes.
   - If the option name does not match anything in the picker, the tiles are
     marked aria-disabled rather than left as dead controls that silently
     swallow clicks.
*/
(function () {
  'use strict';

  if (window.__msFinishTiles) return;
  window.__msFinishTiles = true;

  function scopeOf(root) {
    return root.closest('.shopify-section') || document;
  }

  function radios(root) {
    var picker = scopeOf(root).querySelector('variant-picker');
    if (!picker) return [];
    var name = root.getAttribute('data-option-name');
    var all = picker.querySelectorAll('input[type="radio"][data-option-name]');
    var out = [];
    for (var i = 0; i < all.length; i++) {
      if (all[i].getAttribute('data-option-name') === name) out.push(all[i]);
    }
    return out;
  }

  function radioFor(list, value) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].value === value) return list[i];
    }
    return null;
  }

  function tilesOf(root) {
    return root.querySelectorAll('[data-ms-finish]');
  }

  function hideThemeRow(root, list) {
    if (root.getAttribute('data-hide-theme-row') !== 'true' || !list.length) return;
    var fs = list[0].closest('fieldset') || list[0].closest('.variant-option');
    if (fs) fs.classList.add('ms-finish-dupe-hidden');
  }

  function sync(root) {
    var list = radios(root);
    var tiles = tilesOf(root);

    // No matching option in the picker: do not present operable controls.
    if (!list.length) {
      for (var d = 0; d < tiles.length; d++) {
        tiles[d].setAttribute('aria-disabled', 'true');
        tiles[d].setAttribute('tabindex', '-1');
      }
      return;
    }

    hideThemeRow(root, list);

    var checked = null;
    for (var i = 0; i < list.length; i++) {
      if (list[i].checked) { checked = list[i].value; break; }
    }

    for (var j = 0; j < tiles.length; j++) {
      var tile = tiles[j];
      var value = tile.getAttribute('data-value');
      var radio = radioFor(list, value);
      var on = value === checked;

      tile.classList.toggle('is-on', on);
      tile.setAttribute('aria-checked', on ? 'true' : 'false');
      tile.setAttribute('tabindex', on ? '0' : '-1');

      // Availability is re-read every time, because changing the other
      // option can take a finish in or out of stock.
      var available = true;
      if (radio) {
        var flag = radio.getAttribute('data-option-available');
        available = flag === null ? !radio.disabled : flag !== 'false';
      }
      tile.classList.toggle('is-out', !available);
      if (available) {
        tile.removeAttribute('aria-disabled');
      } else {
        tile.setAttribute('aria-disabled', 'true');
      }

      var nameEl = tile.querySelector('[data-ms-finish-name]');
      if (nameEl) nameEl.textContent = value + (available ? '' : ', sold out');
    }

    // If nothing is checked yet, keep one tile reachable by Tab.
    if (checked === null && tiles.length) tiles[0].setAttribute('tabindex', '0');

    var out = root.querySelector('[data-ms-finish-value]');
    if (out && checked !== null) out.textContent = checked;
  }

  function refresh() {
    var roots = document.querySelectorAll('[data-ms-finish-root]');
    for (var i = 0; i < roots.length; i++) sync(roots[i]);
  }

  var pending = null;
  function refreshSoon() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; refresh(); }, 60);
  }

  function choose(root, tile) {
    var list = radios(root);
    var radio = radioFor(list, tile.getAttribute('data-value'));
    if (!radio) return false;
    radio.click();
    refreshSoon();
    return true;
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var tile = e.target.closest('[data-ms-finish]');
    if (!tile) return;
    var root = tile.closest('[data-ms-finish-root]');
    if (!root) return;
    e.preventDefault();
    choose(root, tile);
  });

  // Arrow keys move between radios, which is what the role promises.
  document.addEventListener('keydown', function (e) {
    if (!e.target || !e.target.closest) return;
    var tile = e.target.closest('[data-ms-finish]');
    if (!tile) return;

    var step = 0;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') step = 1;
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') step = -1;
    else return;

    var root = tile.closest('[data-ms-finish-root]');
    if (!root) return;

    var tiles = Array.prototype.slice.call(tilesOf(root));
    var at = tiles.indexOf(tile);
    if (at === -1) return;

    e.preventDefault();
    var next = tiles[(at + step + tiles.length) % tiles.length];
    next.focus();
    choose(root, next);
  });

  if (window.MutationObserver) {
    new MutationObserver(refreshSoon).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();